// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getISOWeekYear as fn } from "../getISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getISOWeekYear = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getISOWeekYear;
